import { importRemote } from '@module-federation/utilities';
import { UCL } from '../types/UCL';

export const loadUcl = async (version: string, remoteUclUrl?: string): Promise<UCL | null> => {
  let url = `${remoteUclUrl ?? window.remoteUclUrl}`;
  if (window.platformBaseURL && !url.startsWith('http')) {
    url = `${window.platformBaseURL}${url}`;
  }
  return importRemote({
    url: `${url}/${version}/client`,
    module: './UCL',
    scope: `ucl_mfe_runtime_${version}`
  });
};
